import { createSelector } from 'reselect';

import { getRouteDetail } from './route';
import * as ScheduleModel from '../../models/schedule';
import { getUserDepots } from './user';
import { getSelectedDepot } from './app';
import { selectedDepotDowngradesProps } from '../../models/depot';

export const getScheduleResults = (state) => state.schedule.scheduleResults;
export const getScheduleError = (state) => state.schedule.scheduleError;
export const getEnableRetry = (state) => state.schedule.isRetryEnabled;
export const isRouteScheduling = (state) => state.schedule.isRouteScheduling;
export const isRouteSaveEnabled = (state) => state.schedule.isSaveEnabled;
export const isRouteSchedulingOpen = (state) => state.schedule.open;
export const getOptimise = (state) => state.schedule.optimise;
export const getAbortController = (state) => state.schedule.abortController;
export const getRouteBeforeSchedule = (state) =>
  state.schedule.routeBeforeSchedule;

export const formatScheduleData = createSelector(
  getRouteDetail,
  getOptimise,
  ScheduleModel.formatScheduleData
);

export const getDowngradesProps = createSelector(
  getUserDepots,
  getSelectedDepot,
  selectedDepotDowngradesProps
);

export const isDowngradeRequired = createSelector(
  getOptimise,
  getDowngradesProps,
  ScheduleModel.isDowngradeRequired
);

export const formatScheduleResults = createSelector(
  getRouteBeforeSchedule,
  getScheduleResults,
  ScheduleModel.formatScheduleResults
);

export const getDrawerTitle = createSelector(
  getOptimise,
  ScheduleModel.getDrawerTitle
);

export const getCardTitle = createSelector(
  getDrawerTitle,
  ScheduleModel.getCardTitle
);
